import React, { useState } from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { getThemeColors } from '../utils/themeColors';
import ReviewsModal from './ReviewsModal';

const SocialProof: React.FC = () => {
  const { isDark, isHighContrast } = useTheme();
  const colors = getThemeColors('dark', isDark, isHighContrast);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const stats = {
    rating: 5.0,
    totalReviews: 708,
    verified: true,
    keywords: {
      'equipe': 33,
      'dúvidas': 26,
      'atendimento': 22,
      'eficiente': 18,
      'agilidade': 14,
      'empresa': 14,
      'sinistro': 9,
      'atenção': 9,
      'paciente': 6,
      'atendente': 5
    }
  };

  const testimonials = [
    {
      name: 'Giovani Pereira',
      rating: 5,
      date: '3 meses atrás',
      text: 'Uma empresa sensacional em todos os aspectos. Já tive seguro auto e hoje mantenho seguro de vida. A equipe toda da 7Ases é sensacional. Estão sempre prontos para atender de imediato e muito solícitos para esclarecer quaisquer dúvidas.',
      verified: true
    },
    {
      name: 'Fabiano Quintino',
      rating: 5,
      date: 'um mês atrás',
      text: 'Somente a 7Ases pra ficar no telefone comigo até as 20hs de uma sexta-feira para fazer um endosso no seguro do meu novo carro! 7 Ases….os melhores',
      verified: true
    },
    {
      name: 'Dalila W da Silva',
      rating: 5,
      date: 'um mês atrás',
      text: 'Atendimento ótimo, sempre muito prestativos e rápidos! Tenho seguro da casa e do carro com eles super recomendo! Fui atendida pelo George ele foi muito atencioso',
      verified: true
    },
    {
      name: 'sidinei jubanski',
      rating: 5,
      date: '2 meses atrás',
      text: 'Como sempre muito bem atendido, rápidos eficientes e simpáticos, já sou cliente há muitos anos e super recomendo.',
      verified: true
    },
    {
      name: 'Claudia Pereira',
      rating: 5,
      date: '5 meses atrás',
      text: 'Muito bom atendimento. Sempre prontos para esclarecer as dúvidas de forma simples e direta.',
      verified: true
    },
    {
      name: 'Jaison Galdino',
      rating: 5,
      date: '2 meses atrás',
      text: 'Atendimento sempre de primeira! Corretor muito atencioso e sempre buscando o melhor para o segurado.',
      verified: true
    }
  ];

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, i) => (
      <span key={i} style={{ 
        color: i < rating ? '#FFD700' : '#E5E7EB',
        fontSize: 'clamp(1rem, 2.5vw, 1.2rem)',
        marginRight: '2px'
      }}>
        ★
      </span>
    ));
  };

  return (
    <section style={{ 
      background: colors.secondaryBg, 
      padding: 'clamp(60px, 10vw, 80px) 0',
      borderTop: `1px solid ${colors.borderColor}`,
      borderBottom: `1px solid ${colors.borderColor}`
    }}>
      <div style={{ 
        maxWidth: 1200, 
        margin: '0 auto', 
        padding: '0 clamp(20px, 5vw, 40px)' 
      }}>
        {/* Header da Seção */}
        <div style={{ textAlign: 'center', marginBottom: 'clamp(3rem, 6vw, 4rem)' }}>
          <h2 style={{ 
            fontSize: 'clamp(1.8rem, 5vw, 3rem)', 
            fontWeight: 800, 
            marginBottom: 'clamp(0.8rem, 2vw, 1rem)', 
            color: colors.primaryText 
          }}>
            O que nossos clientes dizem
          </h2>
          <p style={{ 
            fontSize: 'clamp(1rem, 2.5vw, 1.1rem)', 
            color: colors.secondaryText, 
            maxWidth: 600, 
            margin: '0 auto',
            lineHeight: 1.5
          }}>
            Mais de 700 clientes confiam na 7Ases para proteger seus bens mais preciosos
          </p>
        </div>

        {/* Estatísticas do Google Reviews */}
        <div style={{ 
          background: colors.cardBg, 
          borderRadius: 20, 
          padding: 'clamp(1.5rem, 4vw, 2rem)', 
          marginBottom: 'clamp(2rem, 5vw, 3rem)',
          boxShadow: colors.cardShadow,
          border: `1px solid ${colors.borderColor}`
        }}>
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(250px, 35vw, 300px), 1fr))', 
            gap: 'clamp(1.5rem, 3vw, 2rem)', 
            alignItems: 'center' 
          }}>
            {/* Rating Principal */}
            <div style={{ textAlign: 'center' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                gap: 'clamp(0.5rem, 2vw, 1rem)', 
                marginBottom: 'clamp(0.8rem, 2vw, 1rem)',
                flexWrap: 'wrap'
              }}>
                <img 
                  src="https://www.google.com/images/branding/googlelogo/2x/googlelogo_color_92x30dp.png" 
                  alt="Google" 
                  style={{ 
                    height: 'clamp(25px, 5vw, 30px)',
                    width: 'auto'
                  }} 
                />
                <span style={{ 
                  fontSize: 'clamp(1rem, 2.5vw, 1.2rem)', 
                  fontWeight: 600, 
                  color: colors.primaryText 
                }}>
                  Revisões
                </span>
              </div>
              <div style={{ 
                fontSize: 'clamp(2.5rem, 6vw, 3rem)', 
                fontWeight: 800, 
                color: colors.accentText,
                marginBottom: 'clamp(0.3rem, 1vw, 0.5rem)'
              }}>
                {stats.rating}
              </div>
              <div style={{ marginBottom: 'clamp(0.8rem, 2vw, 1rem)' }}>
                {renderStars(stats.rating)}
              </div>
              <div style={{ 
                fontSize: 'clamp(1rem, 2.5vw, 1.1rem)', 
                color: colors.secondaryText,
                marginBottom: 'clamp(0.3rem, 1vw, 0.5rem)'
              }}>
                {stats.totalReviews} reviews
              </div>
              {stats.verified && (
                <div style={{ 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  gap: 'clamp(0.3rem, 1vw, 0.5rem)',
                  color: '#10B981',
                  fontSize: 'clamp(0.8rem, 2vw, 0.9rem)',
                  fontWeight: 600
                }}>
                  <span style={{ fontSize: 'clamp(0.9rem, 2.2vw, 1rem)' }}>✓</span>
                  Verificado
                </div>
              )}
            </div>

            {/* Palavras-chave */}
            <div>
              <h3 style={{ 
                fontSize: 'clamp(1.1rem, 3vw, 1.3rem)', 
                fontWeight: 700, 
                marginBottom: 'clamp(0.8rem, 2vw, 1rem)', 
                color: colors.primaryText 
              }}>
                Palavras mais mencionadas
              </h3>
              <div style={{ 
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: 'clamp(0.3rem, 1vw, 0.5rem)' 
              }}>
                {Object.entries(stats.keywords)
                  .sort(([,a], [,b]) => b - a)
                  .slice(0, 8)
                  .map(([word, count]) => (
                    <span key={word} style={{
                      background: colors.featureGradient,
                      color: 'white',
                      padding: 'clamp(0.3rem, 1vw, 0.5rem) clamp(0.8rem, 2vw, 1rem)',
                      borderRadius: 20,
                      fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)',
                      fontWeight: 600,
                      whiteSpace: 'nowrap'
                    }}>
                      {word} ({count})
                    </span>
                  ))}
              </div>
            </div>
          </div>
        </div>

        {/* Depoimentos */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(clamp(300px, 45vw, 350px), 1fr))', 
          gap: 'clamp(1.5rem, 3vw, 2rem)' 
        }}>
          {testimonials.map((testimonial, index) => (
            <div key={index} style={{ 
              background: colors.cardBg, 
              padding: 'clamp(1.5rem, 4vw, 2rem)', 
              borderRadius: 20, 
              boxShadow: colors.cardShadow,
              border: `1px solid ${colors.borderColor}`,
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-5px)';
              e.currentTarget.style.boxShadow = `0 20px 60px ${colors.shadowColor}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = colors.cardShadow;
            }}>
              {/* Header do Depoimento */}
              <div style={{ 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'flex-start', 
                marginBottom: 'clamp(0.8rem, 2vw, 1rem)',
                flexWrap: 'wrap',
                gap: 'clamp(0.5rem, 1vw, 0.8rem)'
              }}>
                <div style={{ minWidth: 0, flex: 1 }}>
                  <h4 style={{ 
                    fontSize: 'clamp(1rem, 2.5vw, 1.1rem)', 
                    fontWeight: 700, 
                    color: colors.primaryText,
                    marginBottom: 'clamp(0.2rem, 0.5vw, 0.25rem)'
                  }}>
                    {testimonial.name}
                  </h4>
                  <div style={{ 
                    display: 'flex', 
                    alignItems: 'center', 
                    gap: 'clamp(0.3rem, 1vw, 0.5rem)',
                    flexWrap: 'wrap'
                  }}>
                    {renderStars(testimonial.rating)}
                    <span style={{ 
                      fontSize: 'clamp(0.8rem, 2.2vw, 0.9rem)', 
                      color: colors.secondaryText 
                    }}>
                      {testimonial.date}
                    </span>
                  </div>
                </div>
                {testimonial.verified && (
                  <div style={{ 
                    background: '#10B981', 
                    color: 'white', 
                    padding: 'clamp(0.2rem, 0.5vw, 0.25rem) clamp(0.4rem, 1vw, 0.5rem)', 
                    borderRadius: 8, 
                    fontSize: 'clamp(0.7rem, 1.8vw, 0.8rem)', 
                    fontWeight: 600,
                    flexShrink: 0
                  }}>
                    ✓ Verificado
                  </div>
                )}
              </div>

              {/* Texto do Depoimento */}
              <p style={{ 
                color: colors.secondaryText, 
                lineHeight: 1.6,
                fontSize: 'clamp(0.9rem, 2.5vw, 1rem)'
              }}>
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        {/* CTA para Mais Avaliações */}
        <div style={{ 
          textAlign: 'center', 
          marginTop: 'clamp(2rem, 5vw, 3rem)' 
        }}>
          <button
            onClick={() => setIsModalOpen(true)}
            style={{ 
              background: colors.featureGradient, 
              color: 'white', 
              padding: 'clamp(12px, 3vw, 15px) clamp(25px, 5vw, 30px)', 
              borderRadius: 50, 
              border: 'none',
              fontWeight: 600, 
              fontSize: 'clamp(1rem, 2.5vw, 1.1rem)', 
              display: 'inline-flex', 
              alignItems: 'center', 
              gap: 'clamp(6px, 1.5vw, 8px)',
              transition: 'all 0.3s ease',
              boxShadow: `0 4px 15px ${colors.shadowColor}`,
              whiteSpace: 'nowrap',
              cursor: 'pointer'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = `0 8px 25px ${colors.shadowColor}`;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = `0 4px 15px ${colors.shadowColor}`;
            }}>
            <i className="fab fa-google"></i>
            <span style={{ display: window.innerWidth < 480 ? 'none' : 'inline' }}>
              Ver todas as {stats.totalReviews} avaliações
            </span>
            <span style={{ display: window.innerWidth < 480 ? 'inline' : 'none' }}>
              Ver avaliações
            </span>
          </button>
        </div>
      </div>

      {/* Modal de Reviews */}
      <ReviewsModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
      />
    </section>
  );
};

export default SocialProof; 